<div
  [ngStyle]="backgroundStyle()"
  class="rounded-(--taskcard-border-radius)"
>
  <div class="flex flex-col gap-(--taskcard-gap) px-(--taskcard-padding-x) py-(--taskcard-padding-y)">
    @if (config().avatar || config().initials) {
      <app-dynamic
        componentName="Avatar"
        [props]="{
          config: {
            size: '2xl',
            imageUrl: config().avatar,
            initials: config().initials,
          },
        }"
      />
    }

    <app-dynamic
      componentName="DynamicText"
      [props]="{
        config: {
          text: config().title,
          size: 'xl',
          fontWeight: 'semibold',
          whiteSpace: config().whiteSpace,
          cssVarPrefix: 'taskcard-title',
        },
      }"
    />
    @if (config().supportingText1 || config().supportingText2) {
      <div class="flex flex-col gap-1">
        @if (config().supportingText1) {
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: config().supportingText1,
                size: 'base',
                fontWeight: 'semibold',
                whiteSpace: config().whiteSpace,
                cssVarPrefix: 'taskcard-supporting-text-1',
              },
            }"
          />
        }
        @if (config().supportingText2) {
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: config().supportingText2,
                size: 'base',
                fontWeight: 'semibold',
                whiteSpace: config().whiteSpace,
                cssVarPrefix: 'taskcard-supporting-text-2',
              },
            }"
          />
        }
      </div>
    }
  </div>

  @if (config().button || config().metatext) {
    <div
      class="flex items-center gap-(--taskcard-gap) p-(--taskcard-padding-x) bg-(--taskcard-action-background) rounded-b-(--taskcard-border-radius)"
    >
      @if (buttonConfig()) {
        <app-dynamic
          componentName="Button"
          [props]="{ config: buttonConfig(), disabled: disabled() }"
          (action)="onButtonClick($event)"
        />
      }

      @if (config().metatext) {
        <div class="flex-1 flex flex-col">
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: config().metatext!.label,
                size: 'base',
                fontWeight: 'semibold',
                whiteSpace: config().whiteSpace,
                cssVarPrefix: 'taskcard-metadata',
              },
            }"
          />
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: config().metatext!.date,
                size: 'base',
                fontWeight: 'semibold',
                whiteSpace: config().whiteSpace,
                cssVarPrefix: 'taskcard-metadata',
              },
            }"
          />
        </div>
      }
    </div>
  }
</div>
